import Client from '@/client'

export default {
  list(offset, limit=20) {
    let query = `{id,uuid,name,file,owner{id,name},status,updated_at}`
    return Client.get(`reports/`, { params: { limit: limit, offset: offset, query: query }})
  },
  create(payload) {
    return Client.post(`reports/`, payload)
  },
  retrieve(uuid) {
    return Client.get(`reports/${uuid}/`)
  },
  download(uuid) {
    return Client.get(`reports/${uuid}/download/`, { responseType: 'blob' })
  },
  headers(uuid, start = 0, size = 50) {
    return Client.get(`reports/${uuid}/headers/`, { params: { start, size } })
  },
  info(uuid) {
    return Client.get(`reports/${uuid}/info/`)
  },
  update(id, payload) {
    return Client.put(`reports/${id}/`, payload)
  },
  patch(id, payload) {
    return Client.patch(`reports/${id}/`, payload)
  },
  destroy(id) {
    return Client.delete(`reports/${id}/`)
  },
  delete(payload) {
    return Client.post('reports/delete/', payload)
  }
}
